<div class="title-wrapper">
  <div class="back" (click)="onBack()">
    <span class="pi pi-arrow-left"></span>
  </div>
  <div class="title">Get started with RFQs</div>
</div>
<div class="no-results">
  <div class="main">
    <div class="icon"></div>
    <div class="main-title">
      RFQs are the way that <b>Buyers</b> get work done with their
      Suppliers.
    </div>
    <div class="subtitle">
      Here you leverage and grow your supplier network to quote, award, and
      track your RFQs.
    </div>
    <div class="action">
      <s-button
        type="primary"
        label="Add RFQ"
        size="large"
        (click)="newProject()"
      ></s-button>
    </div>
  </div>

  <div class="secondary">
    <div class="grid">
      <div class="sm:col-4 col-12">
        <div class="box">
          <div class="header">Faster Quotes with Your Suppliers</div>
          <div class="text">
            Publish RFQs, share files securely, communicate and get quotes
            more quickly all in one place.
          </div>
        </div>
      </div>
      <div class="sm:col-4 col-12">
        <div class="box">
          <div class="header">Track RFQ Status and Score Suppliers</div>
          <div class="text">
            Award your RFQs, track their delivery status, and score your
            suppliers quickly and easily
          </div>
        </div>
      </div>
      <div class="sm:col-4 col-12">
        <div class="box">
          <div class="header">Find New Suppliers</div>
          <div class="text">
            Expand your supplier network by publishing RFQs as opportunities
            to the Sustainment manufacturing community
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
